import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { RemoveRowActionOptions } from '../../../../CIMSTableContext/types/actions/row'
import {
  MutationType,
  Refetch,
  RemoveRPTQuickLinksOptions,
  RPTQuickLink,
} from '../types'

export function useRemove<Remove extends MutationType>({
  mutation,
  permission,
  refetch,
  getLabel,
}: RemoveRPTQuickLinksOptions<Remove> &
  Refetch): RemoveRowActionOptions<RPTQuickLink> {
  const [remove] = mutation({
    ...DefaultMutationHookOptions,
    onCompleted: (remove) => simpleRemoveNotification(getLabel(remove).label),
  })
  return {
    permission,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
